import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { COMPANY } from '../data/company';
export function TermsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] pt-20 sm:pt-24" data-id="element-576" data-mp="2k6vdmfkxpm3t">
      <section className="page-header" data-id="element-577" data-mp="2k496gh1yh8m4">
        <div className="container mx-auto max-w-6xl px-6 md:px-12" data-id="element-578" data-mp="2f6pq9blp6lrj">
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.26,
          ease: [0.23, 1, 0.32, 1]
        }} className="grid gap-8 lg:grid-cols-[1fr_auto] lg:items-end" data-id="element-579" data-mp="2f9lnsytmv8fg">
            <div className="max-w-3xl" data-id="element-580" data-mp="2xztnt821dirf">
              <p className="eyebrow" data-id="element-581" data-mp="3bx02aqfq8vau">Información legal</p>
              <h1 className="mt-5 text-4xl font-medium tracking-[-0.055em] text-white sm:text-6xl" data-id="element-582" data-mp="3bvf7r0texccz">
                Términos y Condiciones
              </h1>
            </div>
            <p className="border-l border-white/15 pl-5 text-xs leading-relaxed text-neutral-400 lg:max-w-[185px]" data-id="element-583" data-mp="2vosd19aee6iq">
              Última actualización:{' '}
              {new Date().toLocaleDateString('es-ES', {
              month: 'long',
              year: 'numeric'
            })}
            </p>
          </motion.div>
        </div>
      </section>

      <section className="section-shell border-b border-white/10" data-id="element-584" data-mp="3emlgccoxoign">
        <div className="container mx-auto max-w-5xl px-6 md:px-12" data-id="element-585" data-mp="3ek8xlxbcq42j">
          <motion.article initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.26,
          delay: 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="mx-auto max-w-3xl border-x border-t border-white/10" aria-label="Contenido de los términos y condiciones" data-id="element-586" data-mp="3im40h68xkpif">
            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-587" data-mp="3coacvujaimm2">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-588" data-mp="37pgxfwkg0lj9">
                1. Objeto
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-589" data-mp="3memtjbnzhvmx">
                Los presentes Términos y Condiciones regulan el uso de los
                servicios ofrecidos por {COMPANY.legalName} (en adelante,
                "Growthly" o "el prestador") a través de su sitio web, así como
                las condiciones de contratación de los servicios de diseño,
                desarrollo web y creación de ecosistemas digitales para
                negocios.
              </p>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-590" data-mp="45m8fe6ql86u">
                Growthly Corporation Systems es actualmente un proyecto y
                servicio en fase de prueba y validación comercial, con un
                servicio ya definido y operativo. No se presenta como una
                sociedad mercantil constituida. Cualquier dato identificativo
                adicional se publicará cuando exista.
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-591" data-mp="bqy7fqchgy03">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-592" data-mp="gozzh0rw07np">
                2. Servicios contratados
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-593" data-mp="6s542qqwundn">
                Growthly ofrece servicios integrales de presencia digital, que
                incluyen, pero no se limitan a:
              </p>
              <ul className="mt-5 space-y-3 border-l border-white/15 pl-4 text-sm leading-relaxed text-neutral-400 sm:text-[15px]" data-id="element-594" data-mp="3tw1jxw4s4caj">
                <li data-id="element-595" data-mp="1n76cpzjaunfg">Diseño y desarrollo de páginas web profesionales.</li>
                <li data-id="element-596" data-mp="1s4euw04g6rgp">Creación de menús y cartas digitales interactivas.</li>
                <li data-id="element-597" data-mp="3o94hn7lp4upn">Gestión integral y mantenimiento técnico continuo.</li>
                <li data-id="element-598" data-mp="3j9i5z2linmiy">Consultoría estratégica digital.</li>
              </ul>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-599" data-mp="3jab1t8ixsrmb">
                Las especificaciones exactas de cada proyecto se detallarán en
                la propuesta comercial aceptada por el cliente.
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-600" data-mp="35aihpw1x19nb">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-601" data-mp="30hz44z38aeii">
                3. Precio y forma de pago
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-602" data-mp="2vhun97yerhrr">
                El precio de nuestro servicio estándar de ecosistema digital es
                de{' '}
                <strong className="font-medium text-white" data-id="element-603" data-mp="2mlbubvq6ftv6">350 € (EUR)</strong>.
                Se trata de un{' '}
                <strong className="font-medium text-white" data-id="element-604" data-mp="2hmiis8ugacxn">
                  pago único por adelantado
                </strong>{' '}
                que incluye la creación de la página web y su gestión y
                mantenimiento completos, sin cuotas ni cargos posteriores.
              </p>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-605" data-mp="16ygpsxaik3qy">
                Los impuestos aplicables se determinan en función del país de
                facturación del cliente y se muestran de forma desglosada antes
                de confirmar el pago. El importe total a abonar es siempre
                visible antes de completar la compra.
              </p>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-606" data-mp="nahad95088f7">
                El pago se realiza online mediante el proveedor de pagos
                contratado por Growthly Corporation Systems, en su entorno
                seguro. Growthly no almacena datos de tarjeta. Los trabajos
                comienzan una vez confirmado el pago del pedido.
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-607" data-mp="xytvuc9zq69i">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-608" data-mp="1cngmha52ikg1">
                4. Prestación y plazos de entrega
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-609" data-mp="17pok1m6srfxl">
                El servicio es digital y se presta de forma remota. Como
                referencia, un proyecto suele requerir entre dos y cuatro
                semanas desde que Growthly dispone de la información y los
                materiales necesarios. Los plazos concretos se acordarán de
                forma individualizada con cada cliente tras la confirmación del
                pago. Growthly se
                compromete a cumplir los plazos establecidos, siempre y cuando
                el cliente proporcione el material y la información necesaria
                (textos, imágenes, accesos) en los tiempos requeridos. Los
                retrasos imputables al cliente modificarán proporcionalmente la
                fecha de entrega final.
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-610" data-mp="1xznxh7gm17h3">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-611" data-mp="22yiec3v0olyk">
                5. Obligaciones del cliente
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-612" data-mp="2qp4l7rtac06z">
                El cliente se compromete a:
              </p>
              <ul className="mt-5 space-y-3 border-l border-white/15 pl-4 text-sm leading-relaxed text-neutral-400 sm:text-[15px]" data-id="element-613" data-mp="2gw70df0tlz57">
                <li data-id="element-614" data-mp="2luibru6rkhpj">Proporcionar información veraz y completa.</li>
                <li data-id="element-615" data-mp="39kuqbnwilcp3">
                  Entregar los materiales necesarios para el desarrollo del
                  proyecto en los plazos acordados.
                </li>
                <li data-id="element-616" data-mp="1ea4k9r6t8w7w">
                  Abonar los importes correspondientes en las fechas
                  estipuladas.
                </li>
                <li data-id="element-617" data-mp="19iuwyx8qi4z6">
                  Garantizar que posee los derechos de autor o licencias de uso
                  de cualquier material (imágenes, textos, logotipos)
                  proporcionado a Growthly.
                </li>
              </ul>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-618" data-mp="1x9iiwmfhiv4q">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-619" data-mp="1t73zo17wltcx">
                6. Propiedad intelectual
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-620" data-mp="1o6zgu4jiwmjj">
                Una vez abonado el 100% del importe del proyecto, el cliente
                adquiere los derechos de explotación sobre el producto final
                entregado (página web, diseños). Growthly puede solicitar
                autorización al cliente para mostrar el proyecto en material
                promocional; dicha publicación requiere su consentimiento
                previo.
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-621" data-mp="7ojrs77ecy6p">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-622" data-mp="7mp4wnckevzz">
                7. Responsabilidad
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-623" data-mp="ghdakem1yfpb">
                Growthly no se hace responsable de las caídas de servidores de
                terceros (hosting), problemas con proveedores de dominio, o
                cambios en los algoritmos de plataformas externas (Google, Meta)
                que puedan afectar al rendimiento del ecosistema digital una vez
                entregado.
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-624" data-mp="2x5hf9e1lw1bi">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-625" data-mp="2x7c0ktgshvg4">
                8. Cancelaciones y reembolsos
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-626" data-mp="ueljtkn837cv">
                El cliente tiene derecho a la devolución íntegra del importe
                abonado (350 € EUR) si cancela el proyecto antes de que
                comiencen los trabajos, es decir, antes de la presentación de
                la primera propuesta. Una vez iniciada la personalización del
                servicio, puede solicitarse la cancelación y se valorará la
                devolución de la parte proporcional correspondiente al trabajo
                aún no realizado; la parte ya prestada no es reembolsable. Tras
                la entrega y publicación, el servicio se considera prestado en
                su totalidad.
              </p>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-627" data-mp="1r2011k0pb8by">
                Las condiciones completas, el procedimiento de solicitud, los
                plazos y el tratamiento del derecho de desistimiento se
                detallan en la{' '}
                <a href="/reembolsos" className="font-medium text-white underline underline-offset-4 hover:no-underline" data-id="element-628" data-mp="216gg4b6cwlep">
                  Política de Reembolsos
                </a>
                , que forma parte de estos Términos y Condiciones.
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-629" data-mp="2jxr1kctbc5z7">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-630" data-mp="2f7ao4sphskcu">
                9. Legislación aplicable
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-631" data-mp="2b55vnxas5trs">
                Estos Términos y Condiciones se rigen por la legislación
                española. Para la resolución de cualquier controversia que
                pudiera derivarse de la prestación de los servicios, las partes
                se someten a los Juzgados y Tribunales competentes.
              </p>
            </section>

            <section className="px-6 py-8 sm:px-10 sm:py-10" data-id="element-632" data-mp="160qup46jqzaq">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-633" data-mp="r8qfq1zn4cfr">
                10. Contacto
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-634" data-mp="w71pydtukoyi">
                Para cualquier consulta sobre estos términos, sobre un pedido o
                sobre el servicio contratado, puede escribirnos a{' '}
                <a href={`mailto:${COMPANY.supportEmail}`} className="font-medium text-white underline underline-offset-4 hover:no-underline" data-id="element-635" data-mp="8bffae29vcyq">
                  {COMPANY.supportEmail}
                </a>{' '}
                o escribir al {COMPANY.phone}. Respondemos en un plazo máximo
                de 3 días hábiles.
              </p>
            </section>
          </motion.article>
        </div>
      </section>
    </div>;
}